import React from 'react';

import {Container, Text} from './style'

export function TextCounter({count,total, ...rest}){
    return(
        <Container {...rest}>
            <Text>{count}/{total}</Text>
        </Container>
    )
}
